export default {
  icon: 'mdi-delete',
  name: 'Tableau de bord',
  title: 'Tableau de bord',
  noItems: 'Aucune DI',
  premiumIcon: 'verified',
  premiumTooltip: 'Premium',
  titles: {
    fullDay: '{title} sur la journée',
    openHours: "{title} depuis l'ouverture de l'agence",
    requestsByEpex: 'Charge moyenne de DI & DIT des techniciens par EPEX',
    requestsByProperties: 'Installations portant le plus de DI',
    requestsByTechnician: 'Charge de DI par technicien',
    requestsByTime: 'Signalisation de DI',
    requestsFlow: 'Flux DI',
  },
  filters: {
    technician: 'Technicien',
    technicians: {
      notScheduled: 'Non ordonnancé',
      scheduled: 'Ordonnancé',
    },
    property: 'Installation',
    properties: {
      notScheduled: 'Non ordonnancée',
      scheduled: 'Ordonnancée',
    },
    period: 'Période',
    entity: 'Entité',
    fullDay: 'Sur la journée',
    openHours: "Depuis l'ouverture de l'agence",
    custom: 'Personnalisée',
  },
  labels: {
    hour: 'Heures de signalisation',
    day: 'Jours de signalisation',
  },
  vigilance: {
    expired: 'Hors respect délai',
    status1: "En attente d'appel tech",
    status2: 'En attente de prise en charge',
    paused: 'En pause',
    notTransmitted: 'Affectée non transmise',
    deposed: 'Non déposé sur PDA',
    lastHour: 'Heure glissante',
    thisDay: 'Cumul',
  },
};
